import React from 'react';
import { FormattedMessage } from 'react-intl';
import NoData from '~/features/base/components/NoData';
import CommaSeparatedList from '~/features/base/components/CommaSeparatedList';
import { MmtPropertiesResponse } from '~/api/models';

interface MmtPropertiesProps {
    mmtProperties?: MmtPropertiesResponse;
}

const MmtProperties: React.FC<MmtPropertiesProps> = ({ mmtProperties }) => {
    if (!mmtProperties || (!mmtProperties.vehicleEnergyType && !mmtProperties.mmtHeadUnit && !(mmtProperties.mmtFunctions && mmtProperties.mmtFunctions.length > 0)) ) {
        return <NoData/>;
    }

    return (
        <div>
            {mmtProperties.vehicleEnergyType && <div className={'word-break'}>
                <label><FormattedMessage id='intl-msg:vehicleEnergyType'/>:</label>{' '}
                {mmtProperties.vehicleEnergyType}
            </div>}
            {mmtProperties.mmtHeadUnit && <div className={'word-break margin-top-10 margin-bottom-10'}>
                <label><FormattedMessage id='intl-msg:mmtHeadUnit'/>:</label>{' '}
                {mmtProperties.mmtHeadUnit}
            </div>}
            {mmtProperties.mmtFunctions && mmtProperties.mmtFunctions.length > 0 ? (
                <div className={'word-break'}>
                    <label><FormattedMessage id='intl-msg:mmtFunctions' />:</label>{' '}
                    <CommaSeparatedList>{mmtProperties.mmtFunctions.map(fn => fn.name || fn)}</CommaSeparatedList>
                </div>
            ) : <div className={'word-break'}>
                <label><FormattedMessage id='intl-msg:mmtFunctions' />:</label>{' '}
                <NoData/> </div>}
        </div>
    );
};

export default MmtProperties;
